import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DataSource } from '@angular/cdk/collections';
import { MapService } from '../google-map/map.service';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/switchMap';
/*import 'rxjs/add/observable/forkJoin';*/
import { delay } from 'rxjs/operator/delay';

import { FormsModule } from "@angular/forms";
import { MdSnackBar, MdDialog, DateAdapter } from '@angular/material';

import { ClientiService } from './../../services/clienti.service';
import { ClienteModel } from '../../models/clienti/cliente.model';
import { PartiteService } from "../../services/partite.service";
import { IncassiDettaglioService } from "../../services/incassi-dettaglio.service";
import { IncassoModel } from "../../models/incassi/incasso.model";
import { IncassiService } from '../../services/incassi.service';
import { PartiteSearchModel } from './../../models/incassi/partite-search.model';
import { PartitaListItemModel } from './../../models/incassi/partita-list-item.model';
import { DistintaContantiDialog, DistintaContantiDialogConfigModel } from '../incassi/distinta-contanti.component';
import { DistintaAssegniDialog, DistintaAssegniDialogConfigModel } from '../incassi/distinta-assegni.component';
import { IncassoContantiListItemModel } from '../../models/incassi/incasso-contanti-list-item.model';
import { IncassoAssegniListItemModel } from '../../models/incassi/incasso-assegni-list-item.model';
import { } from '@types/googlemaps';
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { Configurations } from "../../core/configurations";
import { AccontoModel } from '../../models/incassi/acconto.model';
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';
import { AnagraficaClienteModel } from "../../models/clienti/anagrafica-cliente.model";
import { EstrattoContoModel } from "../../models/clienti/estratto-conto.model";
import { ClienteDetailViewModel } from "../../models/clienti/cliente-detail-model";

export class ClienteMarkerOptions implements google.maps.MarkerOptions {
  anchorPoint?: google.maps.Point;
  animation?: google.maps.Animation;
  clickable?: boolean;
  cursor?: string;
  draggable?: boolean;
  icon?: string | google.maps.Icon | google.maps.Symbol;
  label?: string | google.maps.MarkerLabel;
  map?: google.maps.Map | google.maps.StreetViewPanorama;
  opacity?: number;
  optimized?: boolean;
  place?: google.maps.Place;
  position: google.maps.LatLng | google.maps.LatLngLiteral;
  shape?: google.maps.MarkerShape;
  title?: string;
  visible?: boolean;
  zIndex?: number;
}

@Component({
  selector: 'app-cliente-detail',
  templateUrl: './cliente-detail.component.html',
  styleUrls: ['./cliente-detail.component.css'],
  encapsulation: ViewEncapsulation.None // per poter customizzare il css delle tab per sistemare l'overflow
})
export class ClienteDetailComponent implements OnInit {
  isLoading = false;
  cliente: ClienteModel | null;
  showDragOption = true;
  isPosizioneAttuale = false;
  partiteDaSaldareDatasource: PartiteDataSource = null;
  partiteInArchivioDatasource: PartiteDataSource = null;
  accontiDataSource: AccontiDataSource = null;
  anagraficaClientiDataSource: AnagraficaClienteDataSource = null;
  estrattoContoClienteDataSource: EstrattoContoClienteDataSource = null;
  displayedColumns = ['codiceAS400','idDocumento', 'dataDocumento', 'dataScadenza',
   'descrizionePagamento', 'totaleFattura', 'importoResiduo', 'importoAssegnato', 'saldato','incassiSaldoInLavorazione'];
  displayedColumnsStorico = ['idDocumento', 'dataDocumento', 'dataScadenza', 'descrizionePagamento',
   'totaleFattura', 'importoResiduo', 'dataSaldo', 'stato'];
  displayedColumnsAcconto = ['codiceAs400', 'importo'];
  displayedColumnsCliente = ['codiceCliente', 'ragioneSociale', 'indirizzoTabella', 'pIvaCFisc', 'saldo'];
  displayedColumnsEstrattoConto=['valoreStatoTabella','dataDocumento','numDocumento',
  'causaleTabella','numRiferimento','dataScadenzaTabella','importo','dareAvere'];
  tokenCliente: string = null;
  incassoCorrente: IncassoModel = null;
  saving: boolean = false;
  model: PartiteSearchModel = null;
  dataDalStorico?: Date;
  dataAlStorico?: Date;
  codVersioneImg:string;
  defaultMapCenter: google.maps.LatLng = new google.maps.LatLng(44.90493,8.9434313);
  defaultZoom: number = 11;
  isIncassoLoading: boolean;
  hasAssegni:boolean;
  hasContanti:boolean;
  pathImmagini:string=Configurations.baseUrl+"assets/imgs";
  marker;
  anagraficaClienteEstrattiConto: ClienteDetailViewModel;
  private totaleAssegnatoPartiteAcconti: number = 0;
  get totaleAssegnatoAPartiteAcconti() {

    this.totaleAssegnatoPartiteAcconti = 0;
    if (this.partiteDaSaldareDatasource && this.partiteDaSaldareDatasource.partite) {
      this.partiteDaSaldareDatasource.partite.subscribe(s => {
        let rex=/^(\d+(\.\d{1,2}){0,1})$/;
        s.forEach(p => {
          if (rex.test(p.importoAssegnato + '')) {
            this.totaleAssegnatoPartiteAcconti = this.fixedSum(this.totaleAssegnatoPartiteAcconti,parseFloat(p.importoAssegnato+''),false);
            //this.totaleAssegnatoPartiteAcconti += parseFloat(p.importoAssegnato + '');
          }
        });
        if(this.incassoCorrente.totaleAcconto) {
          this.totaleAssegnatoPartiteAcconti=this.fixedSum(this.totaleAssegnatoPartiteAcconti,this.incassoCorrente.totaleAcconto,false);
          //this.totaleAssegnatoPartiteAcconti+=this.incassoCorrente.totaleAcconto;
        }
      });
    }
    return this.totaleAssegnatoPartiteAcconti;
  }
  get residuoDisponibile() {
    
    
    this.updateResiduoDisponibile(this.totaleAssegnatoAPartiteAcconti);
    return this.incassoCorrente.residuoDisponibile;
  }

  constructor(
    private configuration: Configurations,
    private clienteService: ClientiService,
    private partiteService: PartiteService,
    private incassiService: IncassiService,
    private incassiDettaglioService: IncassiDettaglioService,
    private route: ActivatedRoute,
    private location: Location,
    private snackBar: MdSnackBar,
    private distintaContantiDlg: MdDialog,
    private distintaAssegniDlg: MdDialog,
    private map: MapService,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService,
    private dateAdapter: DateAdapter<Date>,
    private changeDetectorRef:ChangeDetectorRef
  ) {

    this.dateAdapter.setLocale('it-IT');
  }
  // fixedSum(a:number,b:number,inverse:boolean):number {
  //   if(!inverse) {
  //     return Math.round((a + b)*1e12)/1e12;
  //   } else {
  //     return Math.round((a - b)*1e12)/1e12;
  //   }
  // }
  fixedSum(a:number,b:number,inverse:boolean):number {
    if(!inverse) {
         return Math.round(Math.round((a + b)*1e12)/1e10)/100;
       } else {
         return Math.round(Math.round((a - b)*1e12)/1e10)/100;
       }
   }
  ripulisciDirty() {
    this.cliente.emailSalvata = this.cliente.eMail;
    this.cliente.cellulareSalvato = this.cliente.cellulare;
    this.cliente.recapitiDirty = false;
  }
  aggiungiAcconto(c: string) {
    let nuovoAcconto: AccontoModel = new AccontoModel();
    nuovoAcconto.codiceAS400 = c;
    nuovoAcconto.importo = null;
    nuovoAcconto.tokenIncasso = this.incassoCorrente.tokenIncasso;

    this.incassoCorrente.accontiIncasso.push(nuovoAcconto);
  }
  aggiungiAcconti() {
    if (!this.isLoading) {
      let clienteComponent = this;
      if (clienteComponent.incassoCorrente) {
        clienteComponent.incassoCorrente.accontiIncasso = clienteComponent.incassoCorrente.accontiIncasso || [];
        let ccliente: string[] = clienteComponent.cliente.codiciClienteAS400;
        let incassoScoped = clienteComponent.incassoCorrente;
        ccliente.map(function (c) {
          let trovato = false;
          if (incassoScoped.accontiIncasso) {
            let accontoCCliente = incassoScoped.accontiIncasso.map(function (cc) {
              if (c === cc.codiceAS400) {
                trovato = true;
              }
            });
          }
          if (!trovato) {
            clienteComponent.aggiungiAcconto(c);
          }
        });
        clienteComponent.accontiDataSource = new AccontiDataSource(this.incassoCorrente.accontiIncasso);
      }
    }
  }
  ngOnInit(): void {
    //alert("pagina dettaglio cliente");
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;
        
      }
    });
    this.isIncassoLoading = false;
    this.isLoading = true;
    let isLoadingCliente: boolean = true;
    let isLoadingIncassi: boolean = true;
    let isLoadingPartite: boolean = true;
    this.model = new PartiteSearchModel();
    let tokenCliente: string = "";
    this.codVersioneImg=Configurations.currentVersionCod;
    // this.route.paramMap.switchMap((params: ParamMap) =>
    //   tokenCliente = params.get('gid')
    // )
    let main = this;
    this.route.params
      .subscribe((result) => {
        tokenCliente = result['gid'];
        this.clienteService.get(tokenCliente)
          .subscribe((c: ClienteModel) => {
            this.cliente = c;
            this.ripulisciDirty();
            let scopeL = this;
            isLoadingCliente = false;
            this.isLoading = isLoadingCliente || isLoadingIncassi || isLoadingPartite;
            this.aggiungiAcconti();

            this.anagraficaClienteEstrattiConto=c.estrattoConto;

            this.anagraficaClientiDataSource = new AnagraficaClienteDataSource(this.anagraficaClienteEstrattiConto.listAnagraficheCliente);
            this.estrattoContoClienteDataSource = 
              new EstrattoContoClienteDataSource(this.anagraficaClienteEstrattiConto.listEstrattiContoPartite);


           // this.accontiDataSource=new AccontiDataSource(this.incassoCorrente.accontiIncasso);
            setTimeout(function () {
              google.maps.event.trigger(this.map, 'resize');
              scopeL.showPosition(c.latitudine, c.longitudine);
            }, 600);
          }
          );
        
        let posizioniCClienti: number[] = [];
        let clienteScoped = this.cliente;
        let clienteComponent = this;
        //prendi l'incasso in lavorazione del cliente: 0 o 1 record al max
        this.incassiService
          .getByCliente(tokenCliente)
          .finally(() => {
            //prendi le partite da sanare: tutte e quelle già assegnate 

            this.partiteService.getList({ tokenCliente: tokenCliente, daSaldare: true, 
              idIncasso: this.incassoCorrente ? this.incassoCorrente.id : null })
              .catch((r: Response, o) => {
                return Observable.throw(r);
              })
              .subscribe((r: PartitaListItemModel[]) => {
                isLoadingPartite = false;
                this.isLoading = isLoadingCliente || isLoadingIncassi || isLoadingPartite;
                this.aggiungiAcconti();
                //let main =this;
                r.map(function(partita){
                  if(partita.importoAssegnato&&partita.importoAssegnato>0) {
                    //nel caso andassimo a prendere un salvataggio con delle assegnazioni, l'importo residuo originale 
                    //non è quello della partita, ma è quello della partita + assegnazione, perché l'importo residuo di quella partita
                    //è già scalato rispetto all'assegnazione
                    partita.importoResiduoOriginale=main.fixedSum(partita.importoResiduo,partita.importoAssegnato,false);
                  } else {
                    partita.importoResiduoOriginale=partita.importoResiduo;
                  }
                });
                this.partiteDaSaldareDatasource = new PartiteDataSource(r);
              },
              error => {
                this.showError("Errore durante la procedura di caricamento delle partite");
                isLoadingPartite=false;
                return false;
              });

          })
          .subscribe((i: IncassoModel) => {
            if (i.id !== 0) {
              clienteComponent.incassoCorrente = i;
              if(i.assegni) {
                i.assegni.map(function(a){
                  a.dataAssegno=new Date( a.dataAssegno);
                  // let year = dateFieldValue.getFullYear();
                  // let month = dateFieldValue.getMonth();
                  // let day = dateFieldValue.getDate();
                  // let dateOnly = new Date(year,month,day);
                  // a.dataAssegno=dateOnly;
                });
              }
              // if (this.incassoCorrente && !this.incassoCorrente.accontoPrecedente)
              //   this.incassoCorrente.accontoPrecedente = 0;
              // if(this.incassoCorrente&&!this.incassoCorrente.acconto){
              //   this.incassoCorrente.acconto=new AccontoModel();
              //   this.incassoCorrente.tokenIncasso=this.incassoCorrente.tokenIncasso;
              // }

              clienteComponent.updateIncassoCorrente(i);
            } else {
              clienteComponent.incassoCorrente = null;
            }
            
            isLoadingIncassi = false;
            clienteComponent.isLoading = isLoadingCliente || isLoadingIncassi || isLoadingPartite;
            this.aggiungiAcconti();
          },
            error => {
              this.showError("Errore durante il caricamento degli incassi");
              isLoadingIncassi=false;
              return false;

            });
      });
      let t=this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          setTimeout(function () {
            google.maps.event.trigger(this.map, 'resize');
            this.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
            this.setMyPosition(position.coords.latitude, position.coords.longitude);
          }, 600);
  
        }, function () {
          t.showError("Posizione corrente non pervenuta");
        });
      } 

  }
  mapClicked($event: MouseEvent) {
    console.log(" " + $event);

  }

  showPosition(latM, lngM) {
    this.map.setCenter(new google.maps.LatLng(latM, lngM));
    this.map.addMarker(
      new google.maps.LatLng(latM, lngM),
      this.cliente.ragioneSociale, ''
    );
    /*let markerOptions: google.maps.MarkerOptions ;
    let mar: google.maps.Marker;
    mar.setDraggable(true);
    mar.setAnimation(google.maps.Animation.DROP);
    mar.setPosition({lat: latM, lng: lngM});
    /*markerOptions= {
      map: this.map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: {lat: latM, lng: lngM},
    };
    this.marker = new google.maps.Marker();
    this.marker.addListener('click', this.toggleBounce());
    */
    //var infowindow = new google.maps.InfoWindow({
    //  content: this.cliente.ragioneSociale
    //});
    /* 
    //this.marker.addListener('click', function() {
    //  infowindow.open(this.map, this.marker);
    //});
    */
  }

  toggleBounce() {

    if (this.marker.getAnimation() !== null) {
      this.marker.setAnimation(null);
    } else {
      this.marker.setAnimation(google.maps.Animation.BOUNCE);
    }

    let lat = this.marker.getPosition().lat();
    let lng = this.marker.getPosition().lng();
    this.cliente.latitudine = lat;
    this.cliente.longitudine = lng;
  }
  useNavigationProps(ev) {
    let scope = this;
    if (ev.target.checked) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          scope.map.deleteMarkers();
          scope.cliente.latitudine = position.coords.latitude;
          scope.cliente.longitudine = position.coords.longitude;
          scope.showPosition(position.coords.latitude, position.coords.longitude);
        }, function () {
          scope.showError("Posizione corrente non pervenuta");
        });
      } else {
        this.showError("Il browser non supporta la geolocalizzazione");
      }
    }

  }
  enableDraggableMarker() {
    this.map.deleteMarkers();
    this.showDragOption = false;
    let scope = this;
    this.map.addMarker(new google.maps.LatLng(this.cliente.latitudine, this.cliente.longitudine), this.cliente.ragioneSociale, null, true);
    let markers = this.map.getMarkers();
    for (let i = 0; i < markers.length; i++) {
      let m = markers[i];
      m.addListener('mouseup', function () {
        let latLngMarker = m.getPosition();
        scope.cliente.latitudine = latLngMarker.lat();
        scope.cliente.longitudine = latLngMarker.lng();
        scope.map.deleteMarkers();
        scope.showPosition(scope.cliente.latitudine, scope.cliente.longitudine);
        scope.showDragOption = true;
      });
    }
  }
  salvaCliente() {
    this.isLoading = true;
    this.clienteService.update(this.cliente)
      .finally(() => this.isLoading = false)
      .catch((r: Response, o) => {
        return Observable.throw(r);
      })
      .subscribe(
        (r: any) => {
          if (r.result.result) {
            this.showInfo("Salvataggio avvenuto con successo");
            this.ripulisciDirty();
          } else {
            this.showError(r.result.message);
          }
        },
        err => {
          this.showError("Errore nel salvataggio");
        });

  }
  eliminaIncasso() {
    this.saving = true;
    this.incassiDettaglioService.delete(this.incassoCorrente).subscribe(
      r => {
        this.incassiService.delete(this.incassoCorrente)
          .finally(
            () => {
              this.saving = false;
              this.incassoCorrente = null;
            })
          .subscribe(
            (resp: any) => {
              //verifica esito e redirect al dettaglio
              if (resp.result.result === false) {
                this.showError(resp.result.message);
                return false;
              } else {
                this.showInfo("Eliminazione avvenuta con successo");
              }
              this.hasAssegni=false;
              this.hasContanti=false;
            },
            error => {
              this.showError("Errore durante la procedura di eliminazione dell' incasso");
            });
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione del dettaglio incasso");
      });
  }

  isRowPartitaDisabled() {
    return !this.incassoCorrente || this.incassoCorrente.statoIncasso.id === 3;
  }

  onSaldatoClick(chkSaldato, row: PartitaListItemModel) {
    if (chkSaldato.checked) {
      let importoAssegnato=row.importoAssegnato;
      if(importoAssegnato===null) {
        importoAssegnato=0;
      } 
      let differenza = this.fixedSum(row.importoResiduoOriginale,importoAssegnato,true);
      
      if(differenza<=this.incassoCorrente.residuoDisponibile) {
        row.importoAssegnato = row.importoResiduoOriginale;
        row.dataSaldo = new Date();
      } else {
        this.showError("Per coprire la partita il residuo incasso non è sufficiente");
        chkSaldato.checked=false;
      } 

    } else {
      row.importoAssegnato = null;
    }

  }
  isOpen(item) {
    return item.isOpen === "True";
  }
  visualizzaPartiteChanged(event) {
    if(event.target.value.toLowerCase()==="true") {
      this.estrattoContoClienteDataSource=
        new EstrattoContoClienteDataSource(this.anagraficaClienteEstrattiConto.listEstrattiContoPartite.filter(this.isOpen));
    } else {
      this.estrattoContoClienteDataSource=
        new EstrattoContoClienteDataSource(this.anagraficaClienteEstrattiConto.listEstrattiContoPartite);
    }
   
    //this.changeDetectorRef.detectChanges();
  }

  onImportoAssegnatoChange(impAssegnatoInput, row: PartitaListItemModel) {
    row.changedByUser=true;
    let val=impAssegnatoInput.value;
    let rex=/^(\d+(\.\d{1,2}){0,1})$/;
    if(!rex.test(val)) {
      this.showError('Il valore immesso deve essere un valore decimale valido per la valuta, il separatore decimale deve essere "."');
      impAssegnatoInput.value=0;
      //row.importoResiduo=row.importoResiduoOriginale;
    }
    if (row.importoAssegnato && row.importoAssegnato > 0) {
      row.tokenIncasso = this.incassoCorrente.tokenIncasso;
    } else {
      row.tokenIncasso = null;
    }
  }
  nuovoIncasso(): void {
    if (this.cliente.recapitiDirty) {
      this.showError("I campi Email/Cellulare sono stati modificati. Occorre salvare i dati prima di procedere.");
      return;
    }
    if ((this.cliente.eMail == null || this.cliente.eMail.trim() === '') &&
      (this.cliente.cellulare == null || this.cliente.cellulare.trim() === '')
    ) {
      this.showError("Impossibile creare un incasso di un cliente senza recapito email o recapito telefonico.");
      return;
    }
    this.hasAssegni=false;
    this.hasContanti=false;
    this.isIncassoLoading = true;
    if (!this.incassoCorrente) {
      this.incassoCorrente = {
        id: 0,
        tokenIncasso: '',
        tokenCliente: this.cliente.token,
        clienteRagioneSociale: this.cliente.ragioneSociale,
        zona: this.cliente.zona,
        dataIncasso: new Date(),
        statoIncasso: new DizionarioModel(),
        totaleAssegni: 0,
        totaleValuta: 0,
        totaleIncasso: 0,
        accontoPrecedente: 0,
        residuoDisponibile: 0,
        contanti: [],
        assegni: [],
        accontiIncasso: []
        //acconto:new AccontoModel()
      };
      let main = this;
      // if(!this.incassoCorrente.acconto){
      //   this.incassoCorrente.acconto=new AccontoModel();
      //   this.incassoCorrente.acconto.codiceAS400=this.cliente.codiceClienteAS400;
      // }
      //this.incassoCorrente.acconto.tokenIncasso=this.incassoCorrente.tokenIncasso;
      this.incassoCorrente.statoIncasso.id = 1;
      //nuovo incasso:
      this.incassiService.insert(this.incassoCorrente)
        .subscribe((i: any) => {
          this.incassoCorrente.tokenIncasso = i.incasso.tokenIncasso;
          this.incassoCorrente.id=i.incasso.id;
          this.isIncassoLoading = false;
          this.cliente.codiciClienteAS400.map(function (cc) {
            main.aggiungiAcconto(cc);
          });
          this.accontiDataSource = new AccontiDataSource(this.incassoCorrente.accontiIncasso);
        });
    }
  }

  /**
   * verifica di coerenza prima di confermare i dati dell'incasso
   */

  checkConfermaDati(): boolean {
    if (this.cliente.recapitiDirty) {
      this.showError("I campi Email/Cellulare sono stati modificati. Occorre salvare i dati prima di procedere.");
      return false;
    }
    if ((this.cliente.eMail == null || this.cliente.eMail.trim() === '') &&
      (this.cliente.cellulare == null || this.cliente.cellulare.trim() === '')
    ) {
      this.showError("Impossibile confermare un incasso di un cliente senza recapito email o recapito telefonico.");
      return false;
    }
    if (
      (!this.incassoCorrente.assegni || this.incassoCorrente.assegni.length === 0)
      && (!this.incassoCorrente.contanti || this.incassoCorrente.contanti.length === 0)
    ) {
      this.showError("L'incasso non contiene assegni né contanti");
      return false;
    }

    if (this.incassoCorrente.totaleIncasso === 0) {
      this.showError("Il totale incasso non può essere 0");
      return false;
    }

    if (this.incassoCorrente.residuoDisponibile !== 0) {
      
      this.
        showError(
          "Il residuo disponibile non può essere diverso da 0. Rivedere le assegnazioni alle partite o aggiungere contanti o assegni"
        );
      return false;
    }
    let totAcconto = this.incassoCorrente.totaleAcconto;
    if(!totAcconto) {
      totAcconto=0;
    }
    if ((this.fixedSum(this.totaleAssegnatoAPartiteAcconti,totAcconto,true)) === 0) {
      this.showError("Per confermare un incasso occorre assegnare un importo ad almeno una partita");
      return false;
    }
    
    return true;
  }

  /*
  salvaPartite() {

    if (this.partiteDaSaldareDatasource) {
      this.partiteDaSaldareDatasource.partite.first().subscribe(p =>
        p.forEach(pp => {
          
          this.partiteService.save(pp, this.incassoCorrente.tokenIncasso).subscribe(
            data => {
              //this.showInfo("Salvataggio avvenuto con successo");
            },
            error => {
              this.showError("Errore durante la procedura di salvataggio della partita");
              return false;
            }
          );
         
        })

      );
    }
  }*/

  salvaIncasso(): void {
    this.saving = true;
    if (this.incassoCorrente.statoIncasso.id === 1 && this.incassoCorrente.tokenIncasso === '') {
      //NUOVO
      this.incassoCorrente.statoIncasso.id = 2;
      this.saving = false;
    } else {
      //UPDATE
      //significa che stò confermando: faccio il salva partite
      if (this.incassoCorrente.statoIncasso.id === 3) {
        let partite;
        this.partiteDaSaldareDatasource.partite.first().subscribe(p => partite = p);
        let main =this;
        partite.map(function(p){
          p.tokenIncasso=main.incassoCorrente.tokenIncasso;
          p.idIncasso=main.incassoCorrente.id;
        });
        this.partiteService.save(partite, this.incassoCorrente.tokenIncasso)
          .subscribe(
            res => {
              if(res.result) {
              this.incassiService.update(this.incassoCorrente)
                .subscribe(
                  i => {
                    this.saving = false;
                    this.stampaIncasso(this.incassoCorrente.tokenIncasso, this.incassoCorrente.id);
                    this.ngOnInit();
                    this.showInfo("Dati salvati correttamente");
                  },
                  error => {
                    this.saving = false;
                    this.ngOnInit();
                    this.showInfo("Errore nel salvataggio");
                  }
                );
              } else {
                this.saving=false;                
                alert(res.message);
                this.ngOnInit();
                
                this.showInfo(res.message);

              }
            },
            error => {
              this.saving = false;
              this.showError("Errore durante la procedura di chiusura dell'incasso");
              return false;
            });
      }
    }
  }
  aggiornaAcconto(ev) {
    let acValue=ev.target.value;
    
    let rex=/^(\d+(\.\d{1,2}){0,1})$/;
    if (isNaN(parseFloat(acValue+'')) || 
    ( !rex.test(acValue + ''))) {
      this.showError('Il valore immesso deve essere un valore decimale valido per la valuta, il separatore decimale deve essere "."');
    }

    let main=this;
    this.incassoCorrente.totaleAcconto=0;
    this.incassoCorrente.accontiIncasso.map(function(ac){
      if(ac.importo!==null) {
        if (rex.test(ac.importo+ '')) {
          main.incassoCorrente.totaleAcconto = main.fixedSum(main.incassoCorrente.totaleAcconto,parseFloat(ac.importo+''),false);
          //main.incassoCorrente.totaleAcconto+=parseFloat(ac.importo+ '');
        } else {
          ac.importo=0;
        }
      }
      
    });
    this.updateResiduoDisponibile(this.totaleAssegnatoAPartiteAcconti);
   // let unused= main.totaleAssegnatoAPartiteAcconti;
    //TODO: accontototale=sum(acconti);
    //let importo = ev.target.value;
    // if(!this.incassoCorrente.acconto){
    //   this.incassoCorrente.acconto=new AccontoModel();
    //   this.incassoCorrente.acconto.codiceAS400=this.cliente.codiceClienteAS400;
    // }
    // this.incassoCorrente.acconto.tokenIncasso=this.incassoCorrente.tokenIncasso;
  }
  getImportoResiduoPartita(row: PartitaListItemModel): number {
    let importoAssegnato=(row.importoAssegnato ? row.importoAssegnato : 0);
    let residuo = this.fixedSum(row.importoResiduoOriginale , importoAssegnato,true);
    if(residuo<0) {
      this.showError("Attenzione, il valore residuo della partita non può essere minore di zero.");
      this.pulisciImportiAssegnati();
    }
    if(isNaN(residuo)) {
      residuo=row.importoResiduoOriginale;
     }
    return residuo;
    
  }

  /**
   * aggiorna il residuo dell'incasso sommando tutti gli importi assegnati alle partite
   */
  updateResiduoDisponibile(totAssegnato: number) {
    //let accontoAssegnato = this.incassoCorrente.totaleAcconto;
    // if(this.incassoCorrente.acconto&&this.incassoCorrente.acconto.importo){
    //   accontoAssegnato=this.incassoCorrente.acconto.importo;
    // }
    // if(!accontoAssegnato){
    //   accontoAssegnato=0;
    // }
    this.incassoCorrente.residuoDisponibile = this.fixedSum(this.incassoCorrente.totaleIncasso,totAssegnato,true);
    //this.incassoCorrente.residuoDisponibile = this.incassoCorrente.totaleIncasso - totAssegnato;
    this.checkImporti();
  }


  updateTotaleIncasso() {
    this.incassoCorrente.totaleIncasso = this.fixedSum(this.incassoCorrente.totaleValuta,this.incassoCorrente.totaleAssegni,false);
    //this.incassoCorrente.totaleIncasso = this.incassoCorrente.totaleValuta + this.incassoCorrente.totaleAssegni;
    this.checkImporti();
  }

  /**
   * verifica che la somma di acconto precedente e totale incasso sia superiore ai valori immessi nei campi importo assegnato e spesa.
   * Se ci sono eccedenze si emette l’alert e si cancellano i dati dai campi degli importi assegnati.
   * Si aggiorna anche il campo residuo disponibile.
   */
  checkImporti() {
    let totAcconto = this.incassoCorrente.totaleAcconto;
    if(!totAcconto) {
      totAcconto=0;
    }
    let totaleDistinte = this.fixedSum(this.incassoCorrente.totaleIncasso,totAcconto,false);
    if (totaleDistinte< this.totaleAssegnatoAPartiteAcconti) {
      this.snackBar.open("Attenzione: il totale incasso non è coerente con le assegnazioni alle partite. ", "Chiudi", {duration:5000});
      this.pulisciImportiAssegnati();
    }
  }

  /**
   * azzera tutti gli importi assegnati alle fatture
   */
  pulisciImportiAssegnati() {
    if (this.partiteDaSaldareDatasource) {
      this.partiteDaSaldareDatasource.partite.subscribe(s => {
        s.forEach(p => {
          p.importoAssegnato = 0;
          p.flagSaldato=false;
        });
      });
    }

  }

  confermaIncasso() {
    if (this.checkConfermaDati()) {
      
      this.incassoCorrente.statoIncasso = new DizionarioModel();
      this.incassoCorrente.statoIncasso.id = 3;
      this.salvaIncasso();
      // this.totaleAssegnatoPartiteAcconti=0;
    }
  }

  /**
   * Apre la dialog per l'inserimento dei contanti:
   * alla chiusura verifica se è stato premuto salva o annulla
   * e nel primo caso copia i risultati restituiti nell'incasso corrente
   * aggiornando i totali, altrimenti non fa niente
   */
  openDistintaContanti() {
    let dataIncasso = new DistintaContantiDialogConfigModel(this.incassoCorrente, false);
    let dlgRef = this.distintaContantiDlg.open(DistintaContantiDialog,
      { data: dataIncasso })
      .afterClosed().subscribe((res: IncassoModel) => {

        // se è stato fatto il salvataggio, copio il risultato nella lista dei contanti e aggiorno il totale dell'incasso corrente
        if (res != null) {
          // this.incassoCorrente.contanti =
          //   res.contanti
          //     .map((cont: IncassoContantiListItemModel) => Object.assign({}, cont));

          // this.incassoCorrente.totaleValuta = res.totaleValuta;
          // this.updateTotaleIncasso();
          this.updateIncassoCorrente(res);
        }

      });
  }

  openDistintaAssegni() {
    let dataIncasso = new DistintaAssegniDialogConfigModel(this.incassoCorrente, false);
    let dlgRef = this.distintaAssegniDlg.open(DistintaAssegniDialog,
      { data: dataIncasso, width: '80%' })
      .afterClosed().subscribe((res: IncassoModel) => {

        // se è stato fatto il salvataggio, copio il risultato nella lista degli assegni e aggiorno il totale dell'incasso corrente
        if (res != null) {
          // this.incassoCorrente.assegni = res.assegni.map(
          //   (ass: IncassoAssegniListItemModel) => Object.assign({}, ass)
          // );
          // this.incassoCorrente.totaleAssegni = res.totaleAssegni;
          // this.updateTotaleIncasso();
          this.updateIncassoCorrente(res);

        } else if (dataIncasso.reload) {
          this.updateIncassoCorrente(dataIncasso.incassoResult);
        }
      });
  }
  recapitiChange() {
    if (this.cliente.eMail !== this.cliente.emailSalvata
      || this.cliente.cellulare !== this.cliente.cellulareSalvato
    ) {
      this.cliente.recapitiDirty = true;
    } else {
      this.cliente.recapitiDirty = false;
    }
  }
  updateIncassoCorrente(res: IncassoModel) {
    this.incassoCorrente.contanti =
      res.contanti
        .map((cont: IncassoContantiListItemModel) => Object.assign({}, cont));

    this.incassoCorrente.totaleValuta = res.totaleValuta;

    this.incassoCorrente.assegni = res.assegni.map(
      (ass: IncassoAssegniListItemModel) => {
        let obj = Object.assign({}, ass);
        obj.dataAssegno = new Date(obj.dataAssegno);
        return obj;
      }
    );
    this.incassoCorrente.totaleAssegni = res.totaleAssegni;
    if(this.incassoCorrente.assegni!=null && this.incassoCorrente.assegni.length>0) {
      this.hasAssegni=true;
    }
    if(this.incassoCorrente.contanti!=null&&this.incassoCorrente.contanti.length>0) {
      this.hasContanti=true;
    }
    this.updateTotaleIncasso();
  }

  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 10000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 10000 });
  }

  search() {
    //OLD
    //this.partiteInArchivioDatasource = 
    //new PartiteDataSource(this.partiteService, 
    //{tokenCliente: this.cliente.token, dataAl: this.model.dataAl, dataDal: this.model.dataDal });
    this.model.dataDal = this.dataDalStorico;
    this.model.dataAl = this.dataAlStorico;

    this.isLoading = true;
    this.model.tokenCliente = this.cliente.token;
    this.partiteService.getList(this.model)
      .finally(() => this.isLoading = false)
      .catch((r: Response, o) => {
        return Observable.throw(r);
      })
      .subscribe((r: PartitaListItemModel[]) => {
        this.partiteInArchivioDatasource = new PartiteDataSource(r);
      });
  }


  /* STAMPA  */
  stampaIncasso(incassoToken, incassoid) {
    //ritorna il pdf 

    let self = this;

    // Status flag used in the template.
    let pending = true;

    // Create the Xhr request object
    let xhr = new XMLHttpRequest();
    let preurl = this.configuration.apiBaseUrlStampe;
    let MethodPrint = "printIN";
    let url = preurl + MethodPrint + "/" + incassoToken+"/"+this.cliente.token;
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    let scope = this;

    // Xhr callback when we get a result back
    // We are not using arrow function because we need the 'this' context
    xhr.onreadystatechange = function () {

      // We use setTimeout to trigger change detection in Zones
      setTimeout(() => { pending = false; }, 0);
      // If we get an HTTP status OK (200), save the file using fileSaver
      if (xhr.readyState === 4 && xhr.status === 200) {
        let blob = new Blob([this.response], { type: 'application/pdf' });
        //fileSaver.saveAs(blob, 'Report.pdf');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, "incasso " + incassoid + ".pdf");
        } else {
          let urlBlob = window.URL.createObjectURL(blob);
          window.open(urlBlob);
        }
      }
    };

    // Start the Ajax request
    xhr.send();
  }

  onSearchFocus() {
    //initDatePicker();
  }

}



/* DATASOURCE */
export class PartiteDataSource extends DataSource<any> {
  partite: Observable<PartitaListItemModel[]> = null;

  constructor(private data: PartitaListItemModel[]) {
    super();
  }
  connect(): Observable<PartitaListItemModel[]> {
    this.partite = Observable.of(this.data);
    return this.partite;
  }
  disconnect(): void { }

}
export class AccontiDataSource extends DataSource<any> {
  acconti: Observable<AccontoModel[]> = null;
  constructor(private data: AccontoModel[]) {
    super();
  }
  connect(): Observable<AccontoModel[]> {
    this.acconti = Observable.of(this.data);
    return this.acconti;
  }
  disconnect(): void {
  }
}

export class AnagraficaClienteDataSource extends DataSource<any> {
  clienti: Observable<AnagraficaClienteModel[]> = null;
  constructor(private data: AnagraficaClienteModel[]) {
    super();
  }
  connect(): Observable<AnagraficaClienteModel[]> {
    this.clienti = Observable.of(this.data);
    return this.clienti;
  }
  disconnect(): void {
  }
}

export class EstrattoContoClienteDataSource extends DataSource<any> {
  estrattiConto: Observable<EstrattoContoModel[]> = null;
  constructor(private data: EstrattoContoModel[]) {
    
    super();
  }
  connect(): Observable<EstrattoContoModel[]> {
    this.estrattiConto = Observable.of(this.data);
    return this.estrattiConto;
  }
  disconnect(): void {
  }
  
 
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/clienti/cliente-detail.component.ts